import { Group, Title } from "@mantine/core";
import RecentOrdersTable from "./RecentOrdersTable";

const Orders = () => {
  return (
    <>
      <Group position="apart" my="xl">
        <Title order={1}>Recent orders</Title>
      </Group>
      <RecentOrdersTable />
    </>
  );
};

export default Orders;
